import { Disposer } from "../Infra/Disposer";
import { SmartAuthErrorReason, SmartAuthManager, SmartAuthProvider, SmartAuthState } from "../Logic/SmartAuthManager";
export class ClearIAL2LoginViewModel {
    constructor(container) {
        this.container = container;
        this.disposer = new Disposer();
        this.smartAuthManager = container.smartAuthManager;
        this.authManager = container.authManager;
    }
    run() {
        this.disposer.reaction(() => this.smartAuthManager.state, (state) => {
            if (state === SmartAuthState.INACTIVE || state === SmartAuthState.ERROR) {
                const callbackHash = this.smartAuthManager.getClearIAL2CallbackHash();
                if (!callbackHash) {
                    console.error("No callbackHash found");
                    return;
                }
                window.location.hash = callbackHash;
            }
        }, { fireImmediately: false, name: "ClearIAL2LoginViewModel_smartAuthManagerState" });
    }
    stop() {
        this.disposer.dispose();
    }
    loginUsingClearCode() {
        const smartAuthResult = SmartAuthManager.checkForClearIAL2RedirectCode();
        if (!smartAuthResult) {
            void this.smartAuthManager.onSmartAuthError("Clear IAL2 login failed. Code not available", SmartAuthErrorReason.CLEAR_AUTH_GENERIC);
            return;
        }
        void this.smartAuthManager.onSmartAuthComplete(smartAuthResult.code, smartAuthResult.state, this.smartAuthManager.getRedirectUri(SmartAuthProvider.CLEAR_IAL2));
    }
}
